import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { TextField } from '@app/components/form-fields/TextField';
import { zodResolver } from '@hookform/resolvers/zod';
import type { UseFormReset } from 'react-hook-form';
import { Controller, useForm } from 'react-hook-form';
import * as z from 'zod';

const formSchema = z.object({
    email: z.string().trim().min(1, 'Email is required'),
});

export type ForgotPasswordFormValues = z.infer<typeof formSchema>;

export type ForgotPasswordFormProps = {
    onSubmit: (
        data: ForgotPasswordFormValues,
        reset?: UseFormReset<ForgotPasswordFormValues>
    ) => void;
};

export const ForgotPasswordForm = ({ onSubmit }: ForgotPasswordFormProps) => {
    const {
        handleSubmit,
        control,
        reset,
        formState: { isValid, isSubmitting },
    } = useForm<ForgotPasswordFormValues>({
        mode: 'all',
        resolver: zodResolver(formSchema),
        defaultValues: {
            email: '',
        },
    });

    return (
        <form onSubmit={handleSubmit((values) => onSubmit(values, reset))}>
            <div className='form-fields-wrapper'>
                <Controller
                    name='email'
                    control={control}
                    render={({ field, fieldState }) => (
                        <TextField
                            fieldState={fieldState}
                            {...field}
                            label={
                                <span className='label-with-action'>
                                    <span>Email</span>
                                </span>
                            }
                            type='text'
                            placeholder='Enter your Email'
                        />
                    )}
                />
            </div>
            <StyledButtonGroup justify='flex-end'>
                <StyledButton
                    htmlType='submit'
                    type='primary'
                    size='large'
                    block
                    disabled={!isValid}
                    loading={isSubmitting}
                >
                    Submit
                </StyledButton>
            </StyledButtonGroup>
        </form>
    );
};
